<po-page-default p-title="Simples Nacional" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <div class="po-lg-12">
        <span class="po-font-text-uppercase titulo">
          <span class="an an-file-text"></span>
          Simples Nacional
        </span>

        <p class="po-mt-2">
          Envie a planilha com uma aba por empresa, no formato do arquivo de fornecedores.
          O processamento preenche as colunas vazias <b>Simples Nacional (RFB)</b>, <b>Data da consulta</b> e <b>Comprovante / referência</b>.
        </p>
        <p>
          Alguns arquivos são consultados na Brasil API.
        </p>
      </div>

      <div class="po-lg-12 po-mt-2 upload-linha">
        <po-upload
          #uploadPlanilha
          [p-restrictions]="restrictions"
          p-size="medium"
          [p-drag-drop]="true"
          [p-multiple]="false"
          [p-drag-drop-height]="150"
          [p-url]="urlPlaceholder"
          [p-hide-send-button]="true"
          [p-disabled]="enviando"
          p-label="Planilha (.xlsx)">
        </po-upload>
      </div>

      <div class="po-lg-12 acoes">
        <po-button
          p-kind="secondary"
          p-icon="an an-download"
          p-label="Baixar modelo"
          (p-click)="baixarModelo()">
        </po-button>
        <po-button
          p-icon="an an-paper-plane-tilt"
          p-label="Enviar planilha"
          (p-click)="enviar()"
          [p-loading]="enviando"
          [p-disabled]="enviando">
        </po-button>
        <po-button
          p-kind="secondary"
          p-icon="an an-arrows-clockwise"
          p-label="Atualizar"
          (p-click)="atualizar()"
          [p-loading]="consultando"
          [p-disabled]="!jobId || consultando">
        </po-button>
        <po-button
          *ngIf="status?.arquivoPronto"
          p-kind="secondary"
          p-icon="an an-download"
          p-label="Baixar planilha"
          (p-click)="baixar()"
          [p-loading]="baixando"
          [p-disabled]="baixando">
        </po-button>
      </div>

      <div class="po-lg-12 po-mt-3" *ngIf="status">
        <p class="resumo">
          Consulta <b>{{ jobId }}</b>
          · {{ situacao(status.status) }}
          <span *ngIf="status.empresaAtual"> · empresa atual: {{ status.empresaAtual }}</span>
        </p>
        <p class="erro" *ngIf="status.erro">{{ status.erro }}</p>

        <table class="andamento">
          <thead>
            <tr>
              <th>Empresa</th>
              <th>Situação</th>
              <th>CNPJs</th>
              <th>Concluídos</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let empresa of status.empresas">
              <td>
                <div>{{ empresa.nome }}</div>
                <div class="erro" *ngIf="empresa.erro">{{ empresa.erro }}</div>
                <details *ngIf="empresa.cnpjsConcluidos.length" class="cnpjs">
                  <summary>{{ empresa.cnpjsConcluidos.length }} CNPJ(s) concluído(s)</summary>
                  <ul>
                    <li *ngFor="let cnpj of empresa.cnpjsConcluidos">{{ formatarCnpj(cnpj) }}</li>
                  </ul>
                </details>
              </td>
              <td>{{ situacao(empresa.status) }}</td>
              <td>{{ empresa.cnpjs }}</td>
              <td>{{ empresa.comprovantes }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </po-container>
  </div>
</po-page-default>
